import script from "./rightPie2.vue?vue&type=script&setup=true&lang=js"
export * from "./rightPie2.vue?vue&type=script&setup=true&lang=js"

import "./rightPie2.vue?vue&type=style&index=0&id=69f6bed1&scoped=true&lang=css"
script.__scopeId = "data-v-69f6bed1"

export default script